import { TypographyVariantsOptions } from '@mui/material/styles';
import { FONT_BODY, FONT_DISPLAY } from 'themes/tokens';

const display = (fontSize: string, lineHeight: number, letterSpacing: string, fontWeight = 600) => ({
  fontFamily: FONT_DISPLAY,
  fontWeight,
  fontSize,
  lineHeight,
  letterSpacing,
});

const Typography: TypographyVariantsOptions = {
  fontFamily: FONT_BODY,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,

  h1: display('1.875rem', 1.12, '-0.02em'), // 30px
  h2: display('1.5rem', 1.15, '-0.02em'), // 24px
  h3: display('1.25rem', 1.2, '-0.015em'), // 20px
  h4: display('1.125rem', 1.25, '-0.01em'), // 18px
  h5: { fontFamily: FONT_DISPLAY, fontWeight: 600, fontSize: '1rem', lineHeight: 1.3 }, // 16px
  h6: { fontFamily: FONT_DISPLAY, fontWeight: 600, fontSize: '0.875rem', lineHeight: 1.35 }, // 14px

  subtitle1: { fontWeight: 600, fontSize: '0.875rem', lineHeight: 1.4 }, // 14px
  subtitle2: { fontWeight: 600, fontSize: '0.8125rem', lineHeight: 1.4 }, // 13px

  body1: { fontWeight: 400, fontSize: '0.875rem', lineHeight: 1.55 }, // 14px
  body2: { fontWeight: 400, fontSize: '0.8125rem', lineHeight: 1.45 }, // 13px

  caption: { fontWeight: 400, fontSize: '0.75rem', lineHeight: 1.4 }, // 12px
  overline: {
    fontWeight: 600,
    fontSize: '0.6875rem', // ~11px
    lineHeight: 1,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },
  button: {
    fontWeight: 600,
    fontSize: '0.8125rem', // 13px
    lineHeight: 1.2,
    letterSpacing: 0,
    textTransform: 'none',
  },
};

export default Typography;
